var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentSettlement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3919_1717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8846 44.6789H21.8348C21.7904 44.185 21.5627 43.7255 21.1965 43.3909C20.8304 43.0564 20.3523 42.871 19.8563 42.8713H19.8055C19.7613 42.3772 19.5337 41.9174 19.1676 41.5827C18.8014 41.248 18.3231 41.0625 17.827 41.0627H17.7752C17.7395 40.6876 17.5979 40.3304 17.367 40.0327C17.136 39.735 16.8251 39.5091 16.4706 39.3814C16.1162 39.2536 15.7327 39.2293 15.3649 39.3112C14.9971 39.3931 14.6602 39.5779 14.3934 39.844L13.0457 41.1907C12.6737 41.5637 12.4648 42.0691 12.4648 42.5959C12.4648 43.1228 12.6737 43.6281 13.0457 44.0012C13.2297 44.1867 13.4486 44.334 13.6898 44.4346C13.931 44.5352 14.1897 44.587 14.451 44.5871H14.5008C14.5475 45.0797 14.7763 45.5372 15.1423 45.87C15.5084 46.2029 15.9855 46.3872 16.4803 46.3869H16.5311C16.5716 46.8504 16.7742 47.2847 17.1034 47.6135C17.2871 47.7991 17.5058 47.9465 17.7469 48.047C17.9879 48.1476 18.2465 48.1994 18.5077 48.1994H18.5575C18.5932 48.575 18.7351 48.9327 18.9666 49.2306C19.1981 49.5285 19.5096 49.7543 19.8647 49.8817C20.2198 50.0091 20.6038 50.0328 20.9719 49.9501C21.3399 49.8673 21.6768 49.6815 21.9432 49.4143L23.2899 48.0676C23.5678 47.7897 23.7571 47.4356 23.8338 47.0501C23.9105 46.6645 23.8711 46.265 23.7207 45.9018C23.5703 45.5387 23.3156 45.2283 22.9887 45.0099C22.6619 44.7916 22.2777 44.675 21.8846 44.675V44.6789Z",
    fill: "url(#paint0_linear_3919_1717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7815 27.877L27.8733 26.7676C27.298 26.6604 26.7069 26.6727 26.1366 26.804C25.5664 26.9352 25.0293 27.1824 24.5588 27.5303L18.7883 31.8125C18.5221 32.0097 18.3056 32.2663 18.1559 32.5618C18.0062 32.8573 17.9274 33.1836 17.9258 33.5149C17.9242 33.8461 17.9998 34.1732 18.1466 34.4702C18.2935 34.7671 18.5075 35.0258 18.7717 35.2256C19.2697 35.5994 19.8691 35.814 20.4911 35.8413C21.1132 35.8687 21.7291 35.7075 22.258 35.3789L25.0734 33.6133C25.4016 34.2656 26.0129 35.1523 27.0754 35.6992C28.3059 36.3311 29.8029 36.3477 31.5285 35.7471L36.7951 39.54C36.8932 39.6106 37.0085 39.6533 37.1288 39.6636C37.2492 39.674 37.3701 39.6515 37.4787 39.5986L41.1027 37.8242L36.6389 26.5205L33.7815 27.877Z",
    fill: "url(#paint1_linear_3919_1717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9494 36.0554L44.4806 21.7664C44.4123 21.5881 44.2772 21.4435 44.1039 21.3635C43.9306 21.2834 43.7329 21.2741 43.5529 21.3377L41.591 22.0378L44.4923 30.0457C44.5251 30.1361 44.5398 30.2322 44.5355 30.3283C44.5311 30.4245 44.5079 30.5188 44.4671 30.606C44.4263 30.6931 44.3687 30.7714 44.2976 30.8363C44.2265 30.9012 44.1434 30.9514 44.0529 30.9841C43.973 31.013 43.8888 31.0278 43.8039 31.0281C43.6542 31.027 43.5084 30.9801 43.3862 30.8937C43.264 30.8073 43.1711 30.6855 43.1203 30.5447L40.213 22.5291L37.7912 23.3933C37.6986 23.4265 37.6137 23.4779 37.5414 23.5446C37.4691 23.6112 37.4109 23.6916 37.3703 23.7812C37.3297 23.8707 37.3075 23.9675 37.3049 24.0657C37.3024 24.164 37.3196 24.2618 37.3556 24.3533L43.1173 38.9421C43.1532 39.0336 43.207 39.1169 43.2758 39.187C43.3445 39.2571 43.4267 39.3127 43.5174 39.3504C43.6081 39.388 43.7055 39.407 43.8037 39.4061C43.9019 39.4053 43.999 39.3847 44.089 39.3455L49.5578 36.989C49.7308 36.9139 49.8682 36.7749 49.9412 36.6009C50.0141 36.4269 50.0171 36.2315 49.9494 36.0554Z",
    fill: "url(#paint2_linear_3919_1717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6299 23.7816C12.5896 23.6916 12.5316 23.6106 12.4593 23.5435C12.3869 23.4763 12.3018 23.4245 12.209 23.391L9.78522 22.5297L6.88092 30.5463C6.83003 30.687 6.73723 30.8088 6.61501 30.8953C6.49279 30.9817 6.34702 31.0286 6.19733 31.0297C6.11241 31.0294 6.02818 31.0145 5.94831 30.9857C5.8578 30.953 5.77464 30.9027 5.70356 30.8379C5.63249 30.773 5.5749 30.6947 5.53409 30.6076C5.49328 30.5204 5.47004 30.4261 5.46571 30.3299C5.46138 30.2338 5.47604 30.1377 5.50885 30.0472L8.41022 22.0394L6.44538 21.3383C6.26512 21.2741 6.06693 21.2831 5.89319 21.3632C5.71945 21.4433 5.58396 21.5882 5.51569 21.767L0.0488913 36.056C-0.018892 36.232 -0.0161004 36.4273 0.0566834 36.6013C0.129467 36.7752 0.266619 36.9144 0.439516 36.9896L5.90827 39.3461C5.99835 39.385 6.09534 39.4054 6.19347 39.4061C6.2916 39.4068 6.38888 39.3878 6.47951 39.3502C6.57015 39.3126 6.6523 39.2571 6.72109 39.1871C6.78988 39.1171 6.8439 39.034 6.87995 38.9428L12.6417 24.3539C12.678 24.2625 12.6957 24.1649 12.6937 24.0666C12.6917 23.9683 12.67 23.8714 12.6299 23.7816Z",
    fill: "url(#paint3_linear_3919_1717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1865 41.1318C36.7385 41.1323 36.3018 40.9915 35.9385 40.7295L31.2617 37.3604C30.5818 37.5485 29.8802 37.647 29.1748 37.6533C28.213 37.6625 27.2631 37.4401 26.4053 37.0049C25.7342 36.6588 25.1371 36.1851 24.6475 35.6103L23.0361 36.6211C22.2555 37.1078 21.3458 37.3466 20.4268 37.3062C19.5078 37.2657 18.6225 36.9479 17.8877 36.3945C17.4422 36.0574 17.0813 35.6212 16.8337 35.1204C16.5861 34.6196 16.4586 34.0679 16.4612 33.5093C16.4639 32.9506 16.5967 32.4002 16.849 31.9018C17.1013 31.4033 17.4663 30.9705 17.915 30.6377L22.0977 27.5332L21.9346 27.416C21.3582 27.0033 20.6953 26.7272 19.9964 26.6088C19.2974 26.4903 18.5806 26.5326 17.9004 26.7324L15.4238 27.4697L13.4531 26.292L8.71875 38.2744L12.0225 40.1367L13.3564 38.8027C14.0043 38.1558 14.8823 37.7925 15.7979 37.7925C16.7134 37.7925 17.5914 38.1558 18.2393 38.8027C18.5218 39.0863 18.7531 39.4167 18.9229 39.7793C19.3652 39.9285 19.7729 40.1656 20.1214 40.4762C20.4699 40.7868 20.7522 41.1646 20.9512 41.5869C21.3938 41.736 21.8017 41.9729 22.1504 42.2835C22.4991 42.5942 22.7815 42.9721 22.9805 43.3945C23.5382 43.5813 24.039 43.9074 24.4354 44.342C24.8317 44.7765 25.1105 45.3051 25.2453 45.8776C25.3801 46.4501 25.3664 47.0476 25.2056 47.6134C25.0447 48.1791 24.742 48.6944 24.3262 49.1104L24.3076 49.1299L24.5918 49.3428C25.0907 49.7146 25.7072 49.8937 26.3277 49.8471C26.9483 49.8004 27.531 49.5312 27.9688 49.0889L28.0518 49.0049C28.4215 48.6275 28.6669 48.1459 28.7549 47.625C29.1955 47.7494 29.6613 47.7543 30.1044 47.6391C30.5476 47.524 30.9521 47.2929 31.2764 46.9697L31.3369 46.9092C31.7478 46.499 32.0074 45.9616 32.0732 45.3848C32.5173 45.517 32.9888 45.5265 33.4378 45.4122C33.8868 45.2978 34.2964 45.0639 34.623 44.7354L34.6641 44.6943C35.0623 44.2955 35.3189 43.7772 35.3945 43.2187C35.7737 43.3091 36.1684 43.3122 36.5489 43.2277C36.9294 43.1433 37.2858 42.9735 37.5911 42.7313C37.8965 42.4891 38.1428 42.1806 38.3116 41.8293C38.4804 41.478 38.5672 41.0929 38.5654 40.7031L38.126 40.918C37.8331 41.0597 37.5119 41.1328 37.1865 41.1318Z",
    fill: "url(#paint4_linear_3919_1717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7422 11.4746C39.7422 11.5708 39.7611 11.666 39.7979 11.7549C39.8347 11.8438 39.8887 11.9245 39.9567 11.9925C40.0247 12.0605 40.1055 12.1145 40.1943 12.1513C40.2832 12.1881 40.3784 12.207 40.4746 12.207H44.5332C44.7275 12.207 44.9137 12.1299 45.0511 11.9925C45.1885 11.8552 45.2656 11.6689 45.2656 11.4746C45.2656 11.2804 45.1885 11.0941 45.0511 10.9567C44.9137 10.8194 44.7275 10.7422 44.5332 10.7422H40.4746C40.2804 10.7422 40.0941 10.8194 39.9567 10.9567C39.8194 11.0941 39.7422 11.2804 39.7422 11.4746Z",
    fill: "url(#paint5_linear_3919_1717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.953 8.13543C39.0832 8.13643 39.2113 8.10272 39.3241 8.03777L42.3671 6.24968C42.5354 6.15139 42.6578 5.99025 42.7074 5.80171C42.7569 5.61317 42.7295 5.41266 42.6312 5.24431C42.5329 5.07596 42.3718 4.95355 42.1832 4.90401C41.9947 4.85448 41.7942 4.88186 41.6259 4.98015L38.5819 6.77117C38.4417 6.85188 38.3321 6.97677 38.2703 7.12631C38.2086 7.27586 38.198 7.44166 38.2404 7.59782C38.2828 7.75397 38.3757 7.8917 38.5046 7.98949C38.6335 8.08728 38.7912 8.13962 38.953 8.13836V8.13543Z",
    fill: "url(#paint6_linear_3919_1717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5782 16.1782L41.6222 17.9692C41.7055 18.0179 41.7977 18.0496 41.8933 18.0627C41.9889 18.0758 42.0862 18.0699 42.1796 18.0453C42.2729 18.0208 42.3606 17.9781 42.4374 17.9197C42.5143 17.8613 42.5789 17.7884 42.6276 17.705C42.6762 17.6217 42.708 17.5295 42.7211 17.4339C42.7341 17.3383 42.7282 17.241 42.7037 17.1476C42.6792 17.0543 42.6365 16.9667 42.5781 16.8898C42.5197 16.8129 42.4468 16.7483 42.3634 16.6997L39.3204 14.9125C39.2375 14.862 39.1453 14.8285 39.0492 14.8139C38.9532 14.7994 38.8552 14.8041 38.761 14.8277C38.6667 14.8514 38.5782 14.8936 38.5004 14.9518C38.4227 15.0101 38.3573 15.0832 38.308 15.1669C38.2588 15.2507 38.2267 15.3434 38.2137 15.4397C38.2006 15.5359 38.2068 15.6338 38.232 15.7277C38.2571 15.8215 38.3007 15.9094 38.3601 15.9862C38.4196 16.0631 38.4937 16.1273 38.5782 16.1752V16.1782Z",
    fill: "url(#paint7_linear_3919_1717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4668 12.207H9.52539C9.71964 12.207 9.90594 12.1299 10.0433 11.9925C10.1806 11.8552 10.2578 11.6689 10.2578 11.4746C10.2578 11.2804 10.1806 11.0941 10.0433 10.9567C9.90594 10.8194 9.71964 10.7422 9.52539 10.7422H5.4668C5.27255 10.7422 5.08625 10.8194 4.9489 10.9567C4.81154 11.0941 4.73438 11.2804 4.73438 11.4746C4.73438 11.6689 4.81154 11.8552 4.9489 11.9925C5.08625 12.1299 5.27255 12.207 5.4668 12.207Z",
    fill: "url(#paint8_linear_3919_1717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63396 6.24968L10.6769 8.03679C10.7599 8.08732 10.8521 8.12085 10.9481 8.1354C11.0442 8.14996 11.1422 8.14527 11.2364 8.12159C11.3306 8.09791 11.4192 8.05573 11.4969 7.9975C11.5747 7.93926 11.6401 7.86614 11.6893 7.78239C11.7386 7.69864 11.7706 7.60593 11.7837 7.50967C11.7967 7.4134 11.7905 7.3155 11.7654 7.22166C11.7402 7.12782 11.6967 7.03993 11.6372 6.96309C11.5778 6.88625 11.5036 6.82201 11.4191 6.7741L8.37517 4.98015C8.29181 4.93148 8.19969 4.89971 8.10405 4.88665C8.00841 4.87358 7.91114 4.87948 7.81778 4.90401C7.62923 4.95355 7.46809 5.07596 7.3698 5.24431C7.27151 5.41266 7.24412 5.61316 7.29366 5.80171C7.3432 5.99025 7.46561 6.15139 7.63396 6.24968Z",
    fill: "url(#paint9_linear_3919_1717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6769 14.9155L7.63396 16.6997C7.46561 16.7979 7.3432 16.9591 7.29366 17.1476C7.24412 17.3362 7.27151 17.5367 7.3698 17.705C7.46809 17.8734 7.62923 17.9958 7.81778 18.0453C8.00632 18.0949 8.20682 18.0675 8.37517 17.9692L11.4191 16.1811C11.5036 16.1332 11.5778 16.0689 11.6372 15.9921C11.6967 15.9153 11.7402 15.8274 11.7654 15.7335C11.7905 15.6397 11.7967 15.5418 11.7837 15.4455C11.7706 15.3493 11.7386 15.2566 11.6893 15.1728C11.6401 15.0891 11.5747 15.0159 11.4969 14.9577C11.4192 14.8995 11.3306 14.8573 11.2364 14.8336C11.1422 14.8099 11.0442 14.8052 10.9481 14.8198C10.8521 14.8344 10.7599 14.8679 10.6769 14.9184V14.9155Z",
    fill: "url(#paint10_linear_3919_1717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.002 18.5547C26.4023 18.5547 27.7711 18.1395 28.9354 17.3615C30.0997 16.5835 31.0072 15.4778 31.5431 14.184C32.079 12.8903 32.2192 11.4668 31.946 10.0934C31.6728 8.71996 30.9985 7.45841 30.0083 6.46824C29.0182 5.47807 27.7566 4.80376 26.3832 4.53058C25.0098 4.25739 23.5862 4.3976 22.2925 4.93347C20.9988 5.46935 19.8931 6.37682 19.1151 7.54113C18.3371 8.70545 17.9219 10.0743 17.9219 11.4746C17.9239 13.3517 18.6705 15.1514 19.9979 16.4787C21.3252 17.806 23.1248 18.5526 25.002 18.5547ZM20.5957 10.627C20.7376 10.4944 20.9264 10.4236 21.1206 10.4302C21.3147 10.4368 21.4982 10.5202 21.6309 10.6621L23.8945 13.0859L28.373 8.28809C28.5057 8.14564 28.6894 8.0617 28.8839 8.05474C29.0784 8.04778 29.2677 8.11837 29.4102 8.25098C29.5526 8.38359 29.6365 8.56735 29.6435 8.76185C29.6505 8.95634 29.5799 9.14564 29.4473 9.28809L24.4336 14.6592C24.365 14.733 24.2818 14.7919 24.1894 14.8322C24.097 14.8724 23.9973 14.8932 23.8965 14.8932C23.7957 14.8932 23.696 14.8724 23.6035 14.8322C23.5111 14.7919 23.428 14.733 23.3594 14.6592L20.5615 11.6611C20.4958 11.591 20.4446 11.5086 20.4108 11.4187C20.3769 11.3287 20.3612 11.233 20.3643 11.137C20.3675 11.0409 20.3896 10.9464 20.4293 10.8589C20.469 10.7714 20.5255 10.6926 20.5957 10.627Z",
    fill: "url(#paint11_linear_3919_1717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.998 22.9492C27.2675 22.9492 29.486 22.2762 31.373 21.0154C33.26 19.7546 34.7307 17.9625 35.5992 15.8658C36.4677 13.769 36.6949 11.4619 36.2522 9.23603C35.8094 7.01017 34.7166 4.96559 33.1118 3.36084C31.5071 1.75609 29.4625 0.663237 27.2366 0.220487C25.0108 -0.222264 22.7036 0.00497177 20.6069 0.873458C18.5102 1.74194 16.7181 3.21267 15.4573 5.09966C14.1964 6.98665 13.5234 9.20515 13.5234 11.4746C13.5268 14.5168 14.7368 17.4335 16.888 19.5847C19.0392 21.7359 21.9558 22.9459 24.998 22.9492ZM24.998 2.92969C26.6881 2.92969 28.3401 3.43084 29.7454 4.36977C31.1506 5.3087 32.2458 6.64323 32.8925 8.20461C33.5393 9.76599 33.7085 11.4841 33.3788 13.1416C33.0491 14.7992 32.2352 16.3218 31.0402 17.5168C29.8452 18.7118 28.3226 19.5256 26.6651 19.8553C25.0075 20.1851 23.2894 20.0158 21.728 19.3691C20.1667 18.7223 18.8321 17.6271 17.8932 16.2219C16.9543 14.8167 16.4531 13.1646 16.4531 11.4746C16.4557 9.20915 17.3568 7.03722 18.9587 5.4353C20.5607 3.83337 22.7326 2.93228 24.998 2.92969Z",
    fill: "url(#paint12_linear_3919_1717)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3919_1717",
    x1: 11.1655,
    y1: 38.1902,
    x2: 21.9426,
    y2: 53.3532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF7461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE3928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3919_1717",
    x1: 15.2858,
    y1: 25.2059,
    x2: 25.4018,
    y2: 48.8209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF7461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE3928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3919_1717",
    x1: 35.8588,
    y1: 19.4849,
    x2: 55.057,
    y2: 37.3011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF7461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE3928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3919_1717",
    x1: -1.44591,
    y1: 19.4849,
    x2: 17.7523,
    y2: 37.3017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF7461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE3928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3919_1717",
    x1: 5.31901,
    y1: 23.9358,
    x2: 27.3542,
    y2: 60.8926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF7461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE3928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3919_1717",
    x1: 39.113,
    y1: 10.5957,
    x2: 39.7128,
    y2: 13.5899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF7461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE3928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3919_1717",
    x1: 37.7004,
    y1: 4.55403,
    x2: 40.611,
    y2: 9.89586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF7461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE3928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3919_1717",
    x1: 37.6921,
    y1: 14.4793,
    x2: 40.6086,
    y2: 19.8281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF7461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE3928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3919_1717",
    x1: 4.10522,
    y1: 10.5957,
    x2: 4.70496,
    y2: 13.5899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF7461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE3928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3919_1717",
    x1: 6.75458,
    y1: 4.5535,
    x2: 9.67107,
    y2: 9.90228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF7461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE3928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3919_1717",
    x1: 6.75458,
    y1: 14.4857,
    x2: 9.66301,
    y2: 19.8293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF7461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE3928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3919_1717",
    x1: 16.3089,
    y1: 2.97852,
    x2: 30.7875,
    y2: 22.1487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF7461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE3928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3919_1717",
    x1: 10.9094,
    y1: -2.29492,
    x2: 34.3747,
    y2: 28.7741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF7461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE3928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3919_1717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSettlement);
export default __webpack_public_path__ + "static/media/payment_settlement.4d52a948934278cb0a7b8e74b83966f3.svg";
export { ForwardRef as ReactComponent };